<div class="flex flex-wrap justify-content-between align-items-center my-3">
    <h2 class="m-0 font-semibold text-base">Customers</h2>
    <div class="flex gap-2">
        <p-button label="Export" class="export-btn" styleClass="add-button" variant="text" [disabled]="true">
            <ng-template #icon>
                <img src="assets/icons/download.svg" alt="export" />
            </ng-template>
        </p-button>
    </div>
</div>

<p-card class="mt-3">
    <app-table-component [data]="customersList()" [columns]="tableColumns" [totalRecords]="totalRecords()" [rows]="rows" [first]="first" (pageChange)="onPageChange($event)"
        [searchControl]="searchControl" [customFilters]="[onboardingFilter, statusFilter, createdDateFilter]"
        searchPlaceholder="Search by name, email, phone..." [showColumnSelector]="false"
        [rowCommand]="redirectToCustomerDetailsPage"
        [rowLink]="customerRowLink" />
</p-card>

@defer (when updateCustomerDialog; prefetch on idle) {
<app-update-customer-form (updatedCustomer)="onCustomerUpdated()" [selectedCustomer]="selectedCustomer" [(visibility)]="updateCustomerDialog" />
}

@defer (when deleteCustomerDialog; prefetch on idle) {
<app-delete-customer-form (deletedCustomer)="onCustomerDeleted()" [selectedCustomer]="selectedCustomer" [(visibility)]="deleteCustomerDialog" />
}